import { ref } from 'vue';
import { acceptHMRUpdate, defineStore } from 'pinia';
import { Entity } from '@repo/core/models';
import { useEntityService } from '@repo/core/services';

export const useEntityStore = defineStore('entity', () => {
  // services
  const entityService = useEntityService();

  // state
  const currentEntity = ref<Entity>(<Entity>{});

  // actions
  const fetchCurrentEntity = async (parameters?: string | undefined) => {
    const result = await entityService.getCurrent(parameters);
    currentEntity.value = result;
    return result;
  };

  const fetchEntities = (parameters: string | undefined) => {
    return entityService.get(parameters);
  };

  const fetchEntityById = (entityId: string) => {
    return entityService.getEntity(entityId);
  };

  const saveEntities = (data: Entity[], options?: any) => {
    return entityService.post(data, options);
  };

  const deleteEntity = async (entityId: string) => {
    await entityService.deleteEntities([entityId]);
  };

  const state = {
    currentEntity
  };

  const actions = {
    fetchEntities,
    fetchEntityById,
    fetchCurrentEntity,
    saveEntities,
    deleteEntity
  };

  return { ...state, ...actions };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useEntityStore, import.meta.hot));
}
